import type {CreateExtArgs, EnvironmentContext} from '@wix/document-manager-core'
import type {CompRef} from '@wix/document-services-types'
import {generateAndInjectImages} from './utils'
import {fetchImagesWithNoBackground, type RemoveImageBackgroundParams} from './requests'

export const removeImagesBackground = async (
    environmentContext: EnvironmentContext,
    createExtArgs: CreateExtArgs,
    componentPointers: CompRef[]
): Promise<void> => {
    return generateAndInjectImages<RemoveImageBackgroundParams>(
        environmentContext,
        createExtArgs,
        componentPointers,
        (_key, url) => ({imageUrl: url}),
        fetchImagesWithNoBackground
    )
}
